module.exports = __webpack_public_path__ + "img/main-mob.1d64bc1a.svg";